module.exports = __webpack_public_path__ + "img/ghpd1.fc4a414e.png";